import { Nav, Tab } from "react-bootstrap";
import { ISiteVisitDetails } from "../../../api/ISiteVisit";
import {
  ILicenceProfile,
  isRadiologicalProtection,
} from "../../../api/LicenceProfile";
import { ComplianceInvestigationsGrid } from "../../../leap-components/ComplianceInvestigations/ComplianceInvestigationsGrid";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";
import { FindingsAndRecommendationsGrid } from "../../../leap-components/FindingsAndRecommendations/FindingsAndRecommendationsGrid";
import { LicenseeReturnsGrid } from "../../../leap-components/LicenseeReturns/LicenseeReturnsGrid";
import { NonCompliancesGrid } from "../../../leap-components/NonCompliances/NonCompliancesGrid";
import { SiteVisitProps } from "./SiteVisitProps";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  siteVisit: ISiteVisitDetails;
  licenceProfile: ILicenceProfile;
}

interface LicenseeReturnsProps {
  siteVisit: ISiteVisitDetails;
  licenceProfile: ILicenceProfile;
}

const LicenseeReturns = ({
  siteVisit,
  licenceProfile,
}: LicenseeReturnsProps) => (
  <LicenseeReturnsGrid
    relatedRecordType="Site Visit"
    relatedrecordId={siteVisit.sitevisitid}
    licenceProfile={licenceProfile}
  />
);

const SubTabs = ({
  className,
  activeKey,
  siteVisit,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
        {!isRadiologicalProtection(licenceProfile) && (
          <Nav.Item>
            <Nav.Link eventKey="ncs">Non Compliances</Nav.Link>
          </Nav.Item>
        )}
        {!isRadiologicalProtection(licenceProfile) && (
          <Nav.Item>
            <Nav.Link eventKey="returns">Licensee Returns</Nav.Link>
          </Nav.Item>
        )}
        {isRadiologicalProtection(licenceProfile) && (
          <Nav.Item>
            <Nav.Link eventKey="findings">
              Findings and Recommendations
            </Nav.Link>
          </Nav.Item>
        )}
        {!isRadiologicalProtection(licenceProfile) && (
          <Nav.Item>
            <Nav.Link eventKey="cis">Compliance Investigations</Nav.Link>
          </Nav.Item>
        )}
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid regardingObjectId={siteVisit.sitevisitid} />
        </Tab.Pane>
        {!isRadiologicalProtection(licenceProfile) && (
          <Tab.Pane eventKey="returns">
            <LicenseeReturns
              siteVisit={siteVisit}
              licenceProfile={licenceProfile}
            />
          </Tab.Pane>
        )}
        {isRadiologicalProtection(licenceProfile) && (
          <Tab.Pane eventKey="findings">
            <FindingsAndRecommendationsGrid
              profileNumber={siteVisit.profile_number}
              regardingObjectId={siteVisit.sitevisitid}
            />
          </Tab.Pane>
        )}
        {!isRadiologicalProtection(licenceProfile) && (
          <Tab.Pane eventKey="cis">
            <ComplianceInvestigationsGrid
              relatedrecordId={siteVisit.sitevisitid}
              relatedRecordType={"Site Visit"}
              licenceProfile={licenceProfile}
            />
          </Tab.Pane>
        )}
        {!isRadiologicalProtection(licenceProfile) && (
          <Tab.Pane eventKey="ncs">
            <NonCompliancesGrid
              relatedRecordType="Site Visit"
              relatedRecordId={siteVisit.sitevisitid}
              licenceProfile={licenceProfile}
            />
          </Tab.Pane>
        )}
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  siteVisit,
  licenceProfile,
}: SiteVisitProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      siteVisit={siteVisit}
      licenceProfile={licenceProfile}
    />
  );
  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
